import { AdminGetUserDetailsResult } from '@cf-shared/admin-user-detail-interface';

/**
 * The server read the user but not PayPro, so `result.error` is set beside the
 * fields it did gather. Decide whether the payment-history card can show what
 * came back, or must say the history is UNKNOWN.
 *
 * Returns the UNKNOWN text when there are no rows to show, and `undefined` when
 * the normal history renderer should run. An absent or empty history here does
 * NOT mean "no payments": the PayPro half is missing, and "this customer was
 * never charged" is the one wrong answer the card must never give. Real rows
 * are safe to show because the server marks them `paymentHistoryPartialError`,
 * and a failed Paddle read already carries its own error text.
 */
export function unreadablePaymentHistoryText(result: AdminGetUserDetailsResult): string | undefined {
  const hasRows = (result.paymentHistory?.length ?? 0) > 0;
  if (hasRows || result.paymentHistoryError) {
    return undefined;
  }
  return `Could not load the PayPro payment history: ${result.error}\nTreat the payment history as UNKNOWN.`;
}
